export default "__VITE_ASSET__C_8yyc9k__"